/**
 * Returns a string representation of the given thing, pluralized if the count is greater than 1.
 * @param thing - The thing to pluralize.
 * @param count - The count of the thing.
 * @returns A string representation of the given thing, pluralized if the count is greater than 1.
 */
export function getPluralized(thing: string, count: number, showCount = true) {
  return `${showCount ? `${count} ` : ""}${thing}${count === 1 ? "" : "s"}`;
}

export function getTime(seconds: number | undefined): string {
  if (seconds === undefined) return "00:00";
  if (seconds < 3600) return getMMSS(seconds);
  return getHHMMSS(seconds);
}

function getHHMMSS(secs: number) {
  const hours = Math.floor(secs / 3600);
  const remainingSeconds = secs % 3600;
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = Math.floor(remainingSeconds % 60);

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

function getMMSS(seconds: number, delimiter = ":") {
  return [
    Math.floor(seconds / 60 / 60),
    Math.floor((seconds / 60) % 60),
    Math.floor(seconds % 60),
  ]
    .join(delimiter)
    .replace(/\b(\d)\b/g, "0$1")
    .replace(/^00:/, "");
}
